import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames/bind';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import SentimentsSvc from '../../../../../services/dbServices/SentimentsSvc';
import { getAverageSentimentText } from '../../../../../helpers/sentimentHelpers';

import Styles from '../styles.module.scss';

const cx = classNames.bind(Styles);

const SentimentByLocation = (props) => {
  const { selectedMainTimePeriod, selectedLocation, pageLink } = props;
  const [isPositiveLocation, setIsPositiveLocation] = useState(true);
  const [positiveLocationList, setPositiveLocationList] = useState([]);
  const [isNegativeLocation, setIsNegativeLocation] = useState(true);
  const [negativeLocationList, setNegativeLocationList] = useState([]);

  const callListingsAPI = async (params) => {
    try {
      const { data } = await SentimentsSvc.getListingsSentiments(params);
      return data;
    } catch (e) {
      console.log(e);
    }
    return { };
  };

  const getPositiveData = async (params) => {
    setIsPositiveLocation(true);
    const data = await callListingsAPI({
      ...params,
      sentiment_categories: 'Very Positive',
    });
    const subList = (data.list || []).map((list) => {
      const sentimentNumber = (list.sentiment || '').replace('%', '');
      return {
        ...list,
        ...getAverageSentimentText(sentimentNumber),
      };
    });
    setIsPositiveLocation(false);
    setPositiveLocationList(subList);
  };

  const getNegativeData = async (params) => {
    setIsNegativeLocation(true);
    const data = await callListingsAPI({
      ...params,
      sentiment_categories: 'Very Negative',
    });
    const subList = (data.list || []).map((list) => {
      const sentimentNumber = (list.sentiment || '').replace('%', '');
      return {
        ...list,
        ...getAverageSentimentText(sentimentNumber),
      };
    });
    setIsNegativeLocation(false);
    setNegativeLocationList(subList);
  };

  const generateSubLocationsData = () => {
    const { entity_type: entityType, entity_id: entityId } = selectedLocation;
    const params = {
      period: selectedMainTimePeriod,
      selection_mode: 'children',
      entity_type: entityType,
      entity_id: entityId,
      per_page: 5,
      sorting: 'ascending',
      sentiment_filter_mode: 'categories',
    };
    getPositiveData(params);
    getNegativeData(params);
  };

  useEffect(() => {
    generateSubLocationsData();
  }, [selectedLocation]);

  const noData = !isPositiveLocation && !positiveLocationList.length
      && !isNegativeLocation && !negativeLocationList.length;

  return (
    <div className={Styles.sentiment_by_location}>
      <div className={Styles.map_sentiment_title}>
        Most positive
      </div>
      <div className={Styles.map_sentiment_rows}>
        {!isPositiveLocation && !positiveLocationList.length && (
          <div className={Styles.map_sentiment_no_data}>
            No recent sentiment data is available
          </div>
        )}
        {positiveLocationList.map((list) => (
          <MapSentimentRow
            key={list.entity_id}
            list={list}
          />
        ))}
      </div>
      <div className={cx('map_sentiment_title', 'negative')}>
        Most negative
      </div>
      <div className={Styles.map_sentiment_rows}>
        {!isNegativeLocation && !negativeLocationList.length && (
          <div className={Styles.map_sentiment_no_data}>
            No recent sentiment data is available
          </div>
        )}
        {negativeLocationList.map((list) => (
          <MapSentimentRow
            key={list.entity_id}
            list={list}
          />
        ))}
      </div>
      {
        !noData && (
          <Link to={pageLink} className={Styles.map_sentiment_see_more}>
            See More
          </Link>
        )
      }
    </div>
  );
};

const MapSentimentRow = ({ list }) => {
  const {
    entity_name: name, sentiment, icon, type,
  } = list;

  return (
    <div className={Styles.map_sentiment_row}>
      <div className={Styles.map_sentiment_text}>
        {name}
      </div>
      <div className={cx('map_sentiment_value', type)}>
        <FontAwesomeIcon icon={icon} />
        {sentiment}
      </div>
    </div>
  );
};

export default SentimentByLocation;
